import React from 'react';
import PropTypes from 'prop-types';
import Button from '../common/Button';

const ConsultaCidTussFilterPanel = ({ onSearch, onFilterChange }) => {
  const handleSearch = (e) => {
    onSearch({ searchName: e.target.value });
  };

  const handleFilterChange = (e) => {
    onFilterChange({ searchCode: e.target.value });
  };

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between p-4 bg-gray-100 rounded-lg w-full space-y-4 sm:space-y-0 sm:space-x-4">
      <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 w-full">
        <input
          type="text"
          placeholder="Buscar por Nome"
          onChange={handleSearch}
          className="flex-grow p-2 border rounded-md border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          aria-label="Buscar por Nome"
        />
        <input
          type="text"
          placeholder="Buscar por Código"
          onChange={handleFilterChange}
          className="flex-grow p-2 border rounded-md border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          aria-label="Buscar por Código"
        />
      </div>
      <div>
        <Button
          type="pesquisar"
          onClick={onSearch}
          label="Buscar"
          className="px-4 text-white bg-blue-500 hover:bg-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
          aria-label="Buscar"
        />
      </div>
    </div>
  );
};

ConsultaCidTussFilterPanel.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
};

export default ConsultaCidTussFilterPanel;
